<template>
    <div
        class="text-list block"
    >
        <div class="division" v-for="block in layout.data" :key="block.title + block.baseline">
            <h4 v-html="block.title" v-if="block.title"/>
            <p v-html="block.baseline" class="baseline" v-if="block.baseline"/>
            <p v-html="block.description" v-if="block.description"/>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.text-list
    display: flex
    flex-wrap: wrap
    justify-content: center
    margin-top: 14%
    margin-bottom: 14%
    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
        page-break-inside: avoid
        break-inside: avoid
        margin-left: 9.6%
        margin-right: 9.6%
        display: block
.division
    width: 320px
    margin-left: 60px
    margin-right: 60px
    min-height: 275px
    @include media-breakpoint-down($hd)
        max-width: 50%
    @include media-breakpoint-down($sm)
        max-width: 100%
        margin-left: 0px
        margin-right: 0px
        min-height: 0
        margin-bottom: 9.6%
    @media print
        min-height: 0
        width: auto
        margin-left: 0
        margin-right: 0
        max-width: initial
        margin-bottom: .6cm
        page-break-inside: avoid
        break-inside: avoid
h4
    font-size: 50px
    font-weight: 500
    color: #ff2b2a
    letter-spacing: -0.0325em
    line-height: 1.5
    @media print
        font-size: 28px
p
    font-size: 17px
    color: #646873
    line-height: 1.7647058824em
    &.baseline
        font-size: 28px
        letter-spacing: -0.0325em
        font-weight: 500
        line-height: 1.4285714286em
        @media print
            font-size: 21px
</style>
